/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import styled from 'styled-components';

const DragListContainerStyled = styled.div`
    width: 100%;
`;

export {
    DragListContainerStyled,
};
